<template>
  <div class="page-header-index-wide page-header-wrapper-grid-content-main">
    <a-card :bordered="false">
      <template v-if="loading">
        <a-skeleton />
        <a-skeleton />
        <a-skeleton />
        <a-skeleton />
        <a-skeleton />
      </template>
      <template v-if="fansInfo">
        <div class="account-center-avatarHolder">
          <div class="avatar">
            <a-avatar :size="85" icon="user" :src="fansInfo.avatar" />
          </div>
          <a-tooltip placement="top">
            <template slot="title">
              <span>用户ID：{{ fansInfo.uid }}</span>
            </template>
            <div class="username">{{ fansInfo.nickname }}</div>
          </a-tooltip>
          <div class="remarks">
            <span>备注：</span>
            <a-input
              :defaultValue="fansInfo.mark"
              @pressEnter="handleSaveRemarks"
              @blur="handleSaveRemarks"
              :style="{ width: '150px' }"
              size="small"
              placeholder="备注信息"
            />
            <!-- <a><a-icon type="edit" /></a> -->
          </div>
        </div>
        <div class="account-center-detail">
          <UserInfoItem :value="fansInfo.wxid" label="微信ID" icon="user" no-text="未知" />
          <UserInfoItem
            :value="
              fansInfo.superiors_info
                ? `${fansInfo.superiors_info.nickname}（UID：${fansInfo.superiors_info.uid}）`
                : '无邀请人'
            "
            label="邀请人"
            icon="user"
            no-text="未知"
          />
          <UserInfoItem
            :value="fansInfo.user_group_info.id"
            label="所属分组"
            icon="team"
            :save="handleSave"
            edit
            change-key="usertype"
            component="select"
            :options="{ options: groups }"
          />
          <UserInfoItem
            :save="handleSave"
            :value="fansInfo.sex == '0' ? '未知' : fansInfo.sex == '1' ? '男' : '女'"
            label="性别"
            icon="paper-clip"
            no-text="未知"
          />
          <UserInfoItem :save="handleSave" :value="fansInfo.address" label="地址" icon="environment" no-text="未知" />
          <UserInfoItem :save="handleSave" :value="fansInfo.order_num" label="订单数" icon="file-done" />
          <UserInfoItem
            :save="handleSave"
            :value="fansInfo.balance"
            label="余额"
            change-key="balance"
            icon="pay-circle"
            edit
          />
          <UserInfoItem :save="handleSave" :value="fansInfo.finished_amount" label="结算返利金额" icon="transaction" />
          <UserInfoItem
            :save="handleSave"
            :value="fansInfo.total_withdraw_money"
            label="累计提现金额"
            icon="transaction"
          />
          <UserInfoItem
            :save="handleSave"
            :value="fansInfo.trjid === 0 ? '无' : fansInfo.trjid"
            change-key="trjid"
            label="上级ID"
            icon="solution"
            edit
          />
          <UserInfoItem
            :save="handleSave"
            :value="fansInfo.order_sixbit"
            change-key="order_sixbit"
            label="追单号"
            icon="taobao-circle"
            edit
          />
          <!--          <p>-->
          <!--            <a-icon type="pay-circle" />-->
          <!--            <span>追单号：<a-input size="small" @blur="handleSaveOrder" placeholder="追单尾号" :style="{width:'120px'}" :defaultValue="fansInfo.order_sixbit" /> </span>-->
          <!--          </p>-->
          <!--          <p>-->
          <!--            <a-icon type="team" />-->
          <!--            所属分组：-->
          <!--            <a-select size="small" v-model="fansInfo.user_group_info.id" placeholder="请选择" allowClear>-->
          <!--              <a-select-option v-for="(item, index) in groups" :key="index" :value="item.id">{{ item.name }}</a-select-option>-->
          <!--            </a-select>-->
          <!--          </p>-->
          <UserInfoItem :value="fansInfo.regtime" label="创建时间" icon="clock-circle" />
          <UserInfoItem :value="fansInfo.latest_check_time" label="最后查券时间" icon="clock-circle" />
          <!--          <p>-->
          <!--            <a-icon type="clock-circle" />-->
          <!--            <span>创建时间：{{ fansInfo.regtime ||'无' }}</span>-->
          <!--          </p>-->
        </div>
        <a-divider />
        <div class="account-center-tags">
          <div class="tagsTitle">标签</div>
          <tags :tags="tags || []" @change="updateTags"></tags>
        </div>
        <a-divider />
        <div class="account-center-tags">
          <div class="tagsTitle">自定备注（此备注在自动改备注功能可设置）</div>
          <remark :remark="useRemark" @change="updateRemark" />
        </div>
        <template v-if="chartData.length > 0">
          <a-divider :dashed="true" />
          <div class="account-center-team">
            <div class="teamTitle">用户画像（参考维度：{{ fansInfo.order_num }}条订单）</div>
            <chart :loading="loading" :sourceData="chartData"></chart>
          </div>
        </template>
      </template>
    </a-card>
  </div>
</template>

<script>
import Chart from './chart'
import FansApi from '@/api/fans'
import Tags from './tags'
import { mapActions, mapGetters } from 'vuex'
import Remark from '@/views/fans/detail/remark'
import UserInfoItem from '@/views/fans/components/UserInfoItem'
import { log } from 'console'
export default {
  components: {
    UserInfoItem,
    Remark,
    Chart,
    Tags,
  },
  props: ['robotid', 'fansid'],
  data() {
    return {
      fansInfo: null,
      loading: false,
      tags: [],
      useRemark: '',
      groups: [],
    }
  },
  computed: {
    chartData() {
      const shopping_habit = this.fansInfo.shopping_habit || []
      const arr = []

      shopping_habit.forEach(val => {
        arr.push({
          item: val.item_tag.split('/')[0] || '其他',
          count: Number(val.total_number),
        })
      })
      if (arr.length == 0) {
        return [
          {
            item: '无订单',
            count: 1,
          },
        ]
      }
      return arr
    },
  },
  created() {
    this.getData()
  },
  methods: {
    ...mapActions(['WEBSOCKER_ACTIONS_SENDROBOTMSG']),

    handleSave(row) {
      const params = Object.assign(
        {
          sub_id: this.robotid,
          uid: this.fansid,
          balance: this.fansInfo.balance,
          integral: this.fansInfo.integral,
          usertype: this.fansInfo.user_group_info.id,
          trjid: this.fansInfo.trjid,
          order_sixbit: this.fansInfo.order_sixbit,
        },
        { [row.key]: row.value }
      )
      return FansApi.updateFensInfo(params).then(res => {
        this.$emit('refresh')
        return res
      })
    },
    getData() {
      this.loading = true
      const promises = [
        FansApi.getFansInfo({
          sub_id: this.robotid,
          uid: this.fansid,
        }),
        FansApi.getGroupList({
          sub_id: this.robotid,
        }),
      ]
      Promise.all(promises)
        .then(([infoRes, groupRes]) => {
          if (infoRes.code === 1) {
            this.fansInfo = infoRes.data
            // console.log('fansInfo=========================',this.fansInfo);
            this.tags = infoRes.data.tag ? infoRes.data.tag.split(',') : []
            this.useRemark = infoRes.data.customer_remark
          } else {
            this.$message.error(infoRes.msg)
          }
          const { data: groups } = groupRes
          this.groups = groups
        })
        .finally(() => {
          this.loading = false
        })
    },
    updateTags(tags) {
      this.tags = tags
      FansApi.updateFansTags({
        sub_id: this.robotid,
        uid: this.fansid,
        tags: tags.join(','),
      }).then(res => {
        if (res.code === 1) {
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    updateRemark(remark) {
      this.useRemark = remark
      FansApi.updateFansRemark({
        sub_id: this.robotid,
        uid: this.fansid,
        remark,
      }).then(res => {
        if (res.code === 1) {
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    handleSaveRemarks(e) {
      const value = e.target.value || ''
      const uid = this.fansInfo.uid
      this.WEBSOCKER_ACTIONS_SENDROBOTMSG({
        robotid: this.robotid,
        type: 'operation_fans',
        data: {
          type: '1',
          value: value,
          uid: uid,
        },
      }).then(result => {
        // this.$message.success('发送请求成功')
      })
    },
  },
}
</script>

<style lang="less" scoped>
.page-header-wrapper-grid-content-main {
  width: 100%;
  height: 100%;
  min-height: 100%;
  transition: 0.3s;

  .account-center-avatarHolder {
    text-align: center;
    margin-bottom: 24px;

    & > .avatar {
      margin: 0 auto;
      width: 104px;
      height: 104px;
      margin-bottom: 20px;
      border-radius: 50%;
      overflow: hidden;

      img {
        height: 100%;
        width: 100%;
      }
    }

    .username {
      color: rgba(0, 0, 0, 0.85);
      font-size: 20px;
      line-height: 28px;
      font-weight: 500;
      margin-bottom: 4px;
    }

    .remarks {
      height: 50px;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }

  .account-center-detail {
    p {
      //margin-bottom: 8px;
      //padding-left: 26px;
      position: relative;
    }

    i {
      position: absolute;
      height: 14px;
      width: 14px;
      left: 0;
      top: 4px;
    }
  }

  .account-center-tags {
    .ant-tag {
      margin-bottom: 8px;
    }
  }

  .tagsTitle,
  .teamTitle {
    font-weight: 500;
    color: rgba(0, 0, 0, 0.85);
    margin-bottom: 12px;
  }
}
</style>
